/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.chevron-down\":[\"Downward arrow\"]}");